
import request from '../request';

// 获取简历扩展数据
export const getCvsExtension = () => {
  return request({
    url: `/v1/cvs/cvs_extension/data`,
    method: 'get',
  });
}
// 更新简历扩展数据
export const updateCvsExtension = (data) => {
  return request({
    url: `/v1/cvs/cvs_extension/data`,
    method: 'post',
    data
  });
}
